import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-propertyregister-grid',
  templateUrl: './propertyregister-grid.component.html',
  styleUrls: ['./propertyregister-grid.component.css']
})
export class PropertyregisterGridComponent implements OnInit {

  title = "Property Register";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/property-register/propertyregister-grid/propertyregister-grid.component.ts